<template>
  <div class="content">
    <nav class="nav">
      <div class="nav-content">
        <div class="logo">
          <img src="../assets/logo.png" alt="logo" style="height:30px;">
        </div>
        <div class="menulist" style="line-height: 60px;">
          <!-- 可配置菜单 -->
          <div style="display: inline-block;" class="menu-content">
            <el-menu
              @select="handleSelect"
              mode="horizontal"
              background-color="#000"
              text-color="#fff"
              router
              active-text-color="#ffd04b"
              :default-active="path">
              <header-menu :navMenus="menuData"></header-menu>
            </el-menu>
          </div>
        </div>
        <div class="user">
          <el-menu
            style="display: inline-block;float: right;"
            :default-active="activeIndex2"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
            background-color="#000"
            text-color="#fff"
            active-text-color="#ffd04b">
            <el-submenu index="6" popper-class="user-submenu">
              <template slot="title"><span class="icon"></span>{{role_name}} <small>({{username}})</small>【项目经理端】</template>
              <el-menu-item index="6-1">修改密码</el-menu-item>
              <el-menu-item index="6-2">退出</el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
      </div>
    </nav>
    <router-view></router-view>
    <FooterContent></FooterContent>
  </div>

</template>

<script>
  import ApiService from "../service/ApiService";
  import FooterContent from "./Common/FooterContent";
  import p from "../service/public";
  import HeaderMenu from "./Common/HeaderMenu";
  import pub from "../service/public";
  export default {
    name: "Main",
    data() {
      return {
        activeIndex: '',
        activeIndex2: '',
        menuData: [],
        menuDataHolter: [],
        menuDataUL: [],
        username: "",
        path: '/home',
        role_name:'',
        LogoutHolter:false,
        LogoutUl:false,

      }
    },
    watch: {
      // 监测路由变化,只要变化了就调用获取路由参数方法将数据存储本组件即可
      $route:{
        handler: function(val, oldVal){
          if(val.path !=oldVal.path){
            this.onRouteChanged();
          }
        },
        deep: true // 深度观察监听
      }
    },
    created() {
      this.getMenulist();
      let accountInfo = localStorage.getItem('UL_WF_UsrInfo');
      this.role_name  = JSON.parse(accountInfo).usrRealName;
      this.username  = JSON.parse(accountInfo).usrMoblie;
    },
    methods: {
      onRouteChanged() {
        let that = this;
        that.path = that.$route.path;
        let menuList = that.menuData;
        for (let i = 0; i < menuList.length; i++) {
          if (menuList[i].childList.length) {
            let subMenuList = menuList[i].childList;
            for (let j = 0; j < subMenuList.length; j++) {
              if (subMenuList[j].childList.length) {
                let subMenu = subMenuList[j].childList;
                for (let idx = 0; idx < subMenu.length; idx++) {
                  if (that.path == subMenu[idx].menuUri) {
                    let page_title = subMenuList[j].menuName + '-' + subMenu[idx].menuName + '(' + menuList[i].menuName + ')';
                    this.$cookies.set('page_title_ul_wf', page_title);
                  }
                }
              } else {
                if (that.path == subMenuList[j].menuUri) {
                  let page_title = subMenuList[j].menuName + '(' + menuList[i].menuName + ')';
                  this.$cookies.set('page_title_ul_wf', page_title);
                }
              }
            }
          }
        }
      },
      handleSelect(key, keyPath) {
        if (key == "6-1") {
          this.$router.push("/changepwd");
          this.$cookies.set('page_title_ul_wf', '修改密码');
        } else if (key == "6-2") {
          let params = {}
          ApiService.UsrLogout(params).then(res => {
            if (res.code == 0) {
              this.$cookies.set(pub.token.token_key, '');//token authorization  post传值需要的
              this.$cookies.set(pub.token.token_role_name, '');
              this.$cookies.set(pub.token.token_usrname, '');//用户名
              this.$cookies.set(pub.token.refresh_key, '');//用来刷新authorization
              localStorage.clear();
              this.$router.push("/login");
            }
          })
        }
      },
      //获取菜单列表
      getMenulist() {
        ApiService.MenuList({}).then(res => {
          if (res.code == 0) {
            this.menuData = res.data.pageList;
            this.onRouteChanged();
          } else if (res.code == 204) {
            pub.refresh(this.getMenulist);
          } else {
            pub.analysisReturnCode(res);
          }

        })
      },

    },
    components: {
      HeaderMenu: HeaderMenu,
      FooterContent: FooterContent
    }
  }
</script>

<style scoped="scoped">
  div:focus, ul:focus {
    outline: 0;
  }

  ul li {
    list-style: none;
    font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  }

  .content {
    width: 100%;
    height: 100%;
    padding-top: 60px;
  }
  .content .nav {
    width: 100%;
    height: 60px;
    background: #000;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    position: fixed;
    top: 0;
    z-index: 200;
    min-width: 1366px;
  }
  .content .nav .nav-content {
    width: 1366px;
    height: 60px;
    margin: 0 auto;
    position: relative;
  }

  .logo {
    width: 280px;
    height: 60px;
    line-height: 60px;
    color: #00a8be;
    float: left;
    text-align: left;
  }
  .menulist {
    width: 900px;
    height: 60px;
    text-align: center;
    position: absolute;
    top: 0;
    left: 50%;
    margin-left: -450px;
    z-index: 2;
  }

  .user {
    width: 350px;
    height: 60px;
    line-height: 60px;
    float: right;
  }
  .user ul{
    width: 100%;
  }
  .user ul li{
    width: 100%;
    text-align: right;
  }

  .menulist ul {
    background: #fff;
    color: #000;
  }

  .menulist >>> ul:focus, .menulist .menu-content:focus {
    outline: 0;
  }

  .menulist ul li {
    display: inline-block;
    width: 80px;
    cursor: pointer;
  }

  .menulist ul li a {
    color: #fff;
    cursor: pointer;
  }
  .heart_list ul {
    width: 120px;
    padding: 0;
  }
  .heart_list ul li {
    color: #000;
    width: 100%;
    height: 30px;
    line-height: 30px;
    font-size: 12px;
    font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  }
  .heart_list ul li a {
    color: #000;
  }

  .heart_list ul li a:hover {
    color: #fff;
  }

  .heart_list ul li:hover {
    color: #fff !important;
    background: #18a689;

  }
  .el-menu-demo >>> .el-submenu__title {
    padding-right: 0;
  }
  .el-menu-demo >>> .el-submenu__title span{
    display: inline-block;
    width: 20px;
    height: 20px;
    background: url('../assets/img/user-icon.png') no-repeat;
    background-size: 20px;
    margin-right:8px;
  }
  .main-content{
    margin: 0 auto;
    width: 1366px;
    min-height: 859px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Main.vue